import { Injectable } from '@angular/core';
import { AppConfig, AppConfigService } from '@app/app-config.service';
import { Observable, EMPTY as empty } from 'rxjs';
import * as esri from 'esri-leaflet';
import { getGisToken } from '@app/modules/gis/gis-token';

@Injectable({
  providedIn: 'root',
})
export class SeisbookLayerService {
  private _config: AppConfig;

  constructor(
    private _appConfig: AppConfigService,
  ) {
    this._config = this._appConfig.getConfig();
  }

  getBasinNames(countries: string[]): Observable<any> {
    if (!countries.length) { return empty; }

    const condition = countries.reduce(
      (prev, country) => prev.length ? `${prev} OR COUNTRY_NAMES = '${country}'` : `COUNTRY_NAMES = '${country}'`, '');

    return new Observable(observer => {
      getGisToken().then(token => {
        const featureQuery = esri.query({
          url: this._config.geobookLayerUrl,
          useCors: true,
          withCredentials: true,
          token
        });

        featureQuery.where(condition);
        featureQuery.fields('BASIN_NAME');

        featureQuery.run((error, featureCollection: any) => {
          if (error) {
            observer.next({});
          } else {
            observer.next(featureCollection.features.map((feature: any) => feature.properties.BASIN_NAME));
          }
        });
      });
    });
  }
}
